import * as React from "react";
import { Labeler } from "@focus/focusUI";
import { getUiProperties } from "../utils/utils";
import { FocusFormDataContext } from "../form/utils";
import { evaluateUiCondition } from "../entities/uiCondition";
export const ConditionalLabeler = ({ uiSchema, schema, children, expand }) => {
    const { isHidden, isDisabled } = getUiProperties(uiSchema);
    const contextData = React.useContext(FocusFormDataContext);
    let labelName = React.useMemo(() => evaluateUiCondition(uiSchema["ui:label"], contextData, schema.title), [uiSchema["ui:label"], contextData, schema.title]);
    return (React.createElement(Labeler, { help: schema.help, labelname: labelName, key: "label", disabled: isDisabled, hidden: isHidden, children: children, expand: expand }));
};
export default ConditionalLabeler;
//# sourceMappingURL=ConditionalLabeler.js.map